export class User {
    id: string = null;
    customerOnly: boolean = null;
    userName: string = null;
    password: string = null;
    confirmPassword: string = null;
    initials: string = null;
    email: string = null;
    profilePictureMediaType: string = null;
    profilePicture: string = null;
    bannerPictureMediaType: string = null;
    bannerPicture: string = null;
    roleIds: string[] = [];
}

export class ChangePasswordModel {
    oldPassword: string = null;
    newPassword: string = null;
    confirmPassword: string = null;
}
